//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createNamespacedHelpers } from 'vuex'
import {
  ACTION_LOAD_PDP_CAROUSEL,
  ACTION_UPDATE_SELECTED_PRODUCT,
  ACTION_SELECTED_FACE_SHAPE_PRODUCT,
} from '@/scripts/store/actions/pdp'
import { MOST_SOLD } from '@/scripts/constants/pdp'
import { Sizes } from '@/scripts/libs/wcs/size'

const { mapActions: mapActionsPdp, mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')

export default {
  name: 'rb-change-style-product',

  props: {
    catEntryId: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
  },

  inject: ['closePanel'],
  computed: {
    ...mapGettersPdp(['selectedProduct', 'carousel']),
    isSelected() {
      return this.$slots.title.some((element) =>
        element?.text?.includes(this.selectedProduct.modelName)
      )
    },
  },
  methods: {
    ...mapActionsPdp({
      updateSelectedProduct: ACTION_UPDATE_SELECTED_PRODUCT,
      loadPDPCarousel: ACTION_LOAD_PDP_CAROUSEL,
      setSelectedFaceShapeProduct: ACTION_SELECTED_FACE_SHAPE_PRODUCT,
    }),
    async onClick() {
      await this.updateSelectedProduct({ id: this.catEntryId })
      const selectedFaceShape = Sizes.normalizeSelectedProduct(this.selectedProduct)
      this.setSelectedFaceShapeProduct({
        selectedFaceShapeProduct: selectedFaceShape,
        selectedFaceShape: MOST_SOLD,
      })
      const allCarouselCatentries = this.carousel.flatMap((item) => item.correlatedCatEntryIds)
      if (!allCarouselCatentries.includes(this.catEntryId)) {
        this.loadPDPCarousel(this.selectedProduct)
      }
      this.closePanel()
    },
  },
}
